'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _VstComponent2 = require('./VstComponent');

var _VstComponent3 = _interopRequireDefault(_VstComponent2);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _copyProps = require('../utils/copy-props');

var _copyProps2 = _interopRequireDefault(_copyProps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VstLilHeadListLink = function (_VstComponent) {
  _inherits(VstLilHeadListLink, _VstComponent);

  function VstLilHeadListLink() {
    _classCallCheck(this, VstLilHeadListLink);

    var _this = _possibleConstructorReturn(this, (VstLilHeadListLink.__proto__ || Object.getPrototypeOf(VstLilHeadListLink)).call(this));

    _this._getIcon = _this._getIcon.bind(_this);
    return _this;
  }

  _createClass(VstLilHeadListLink, [{
    key: '_getIcon',
    value: function _getIcon() {
      return;
    }
  }, {
    key: 'render',
    value: function render() {
      var props = (0, _copyProps2.default)(this.props, ['icon']);
      return _react2.default.createElement(
        'li',
        null,
        _react2.default.createElement(
          'a',
          _extends({}, props, { className: 'vst-link vst-lil-head-list-link' }),
          _react2.default.createElement('span', { className: (0, _classnames2.default)('link-icon', this.props.icon) }),
          _react2.default.createElement(
            'span',
            { className: 'link-text' },
            this.props.children
          )
        )
      );
    }
  }]);

  return VstLilHeadListLink;
}(_VstComponent3.default);

exports.default = VstLilHeadListLink;


/** WEBPACK FOOTER **
 ** ./~/vstui/lib/components/VstLilHeadListLink.js
 **/